import React from 'react';
import { cn } from '@/lib/utils';

const reasons = [
  {
    image: '/images/GenAI/One.png',
    title: 'To become strategic, not stagnant:',
    description: 'Enhance your skills and shift your value.',
  },
  {
    image: '/images/GenAI/Two.png',
    title: 'To stay relevant and gain the edge:',
    description: 'Roles are evolving, and so must you.',
  },
  {
    image: '/images/GenAI/Three.png',
    title: 'To shift your mindset, not just trends:',
    description: 'Rewire how you think and act with purpose.',
  },
  {
    image: '/images/GenAI/Four.png',
    title: 'To 10x your impact with GenAI:',
    description: 'Skip the grunt work and boost your productivity.',
  },
  {
    image: '/images/GenAI/Five.png',
    title: 'To not just learn, but lead:',
    description: 'Build hands-on AI fluency and drive meaningful outcomes.',
  },
];

const ReasonCards = () => {
  return (
    <div className="mx-auto max-w-6xl space-y-6 px-4">
      {/* First row: 1–3 */}
      <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
        {reasons.slice(0, 3).map((reason, index) => (
          <div
            key={index}
            className="flex flex-col items-start gap-4 rounded-2xl bg-[#E9F7F6] p-4"
          >
            <div className="flex items-start gap-4">
              <img
                src={reason.image}
                alt="icon"
                className="h-[80px] w-[80px] rounded-md object-contain md:h-[100px] md:w-[100px]"
              />
              <p
                className={cn(
                  'font-manrope text-[18px] font-extrabold leading-[29.1px] tracking-normal text-black',
                  'md:text-[20px] md:leading-[32px]',
                )}
              >
                {reason.title}
              </p>
            </div>
            <p
              className={cn(
                'font-rubik text-[16px] font-normal leading-[23.64px] tracking-normal text-black',
                'md:leading-[26px]',
              )}
            >
              {reason.description}
            </p>
          </div>
        ))}
      </div>

      {/* Second row: 4–5, centered */}
      <div className="flex flex-col items-center justify-center gap-6 md:flex-row md:justify-center">
        {reasons.slice(3).map((reason, index) => (
          <div
            key={index + 3}
            className="flex min-h-[160px] w-full max-w-[400px] flex-col items-start gap-4 rounded-2xl bg-[#E9F7F6] p-4 md:w-[48%]"
          >
            <div className="flex items-start gap-4">
              <img
                src={reason.image}
                alt="icon"
                className="h-[80px] w-[80px] rounded-md object-contain md:h-[100px] md:w-[100px]"
              />
              <p
                className={cn(
                  'font-manrope text-[18px] font-extrabold leading-[29.1px] tracking-normal text-black',
                  'md:text-[20px] md:leading-[32px]',
                )}
              >
                {reason.title}
              </p>
            </div>
            <p
              className={cn(
                'font-rubik text-[16px] font-normal leading-[23.64px] tracking-normal text-black',
                'md:leading-[26px]',
              )}
            >
              {reason.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReasonCards;
